import classNames from 'classnames';
import Typografed from '@/shared/components/shared/Typografed';
import { tp } from '@/shared/lib/typograf';
import Link from '../../../shared/Link';

export type TariffCardProps = {
    title: string;
    text?: string | null;
    color?: string | null;
    price?: string | null;
    priceNote?: string | null;
    button?: {
        text?: string | null;
        href?: string | null;
        isExternal?: boolean;
    } | null;
    allOptionsLabel?: string | null;
    onAllOptionsClick?: () => void;
};

type Props = TariffCardProps & {
    className?: string;
};

function TariffCard({
    title,
    text,
    color,
    price,
    priceNote,
    button,
    allOptionsLabel,
    onAllOptionsClick,
    className,
}: Props) {
    const hasText = Boolean(text);
    const hasButton = Boolean(button?.href && button?.text);
    const hasAllOptions = Boolean(allOptionsLabel && onAllOptionsClick);

    return (
        <li className={classNames('tariff-card-popup', className)}>
            <div
                className="tariff-card-popup__accent"
                aria-hidden="true"
                style={color ? ({ '--accent-color': color } as React.CSSProperties) : undefined}
            />
            <div className="tariff-card-popup__header">
                <div className="tariff-card-popup__title text-xl">
                    <Typografed>{title}</Typografed>
                </div>
                <div className="tariff-card-popup__divider" aria-hidden="true" />
            </div>
            {hasText && (
                <div
                    className="tariff-card-popup__text text-xs text-opacity wysiwyg"
                    dangerouslySetInnerHTML={{ __html: tp(text ?? '') }}
                />
            )}
            <div className="tariff-card-popup__bottom">
                {(price || priceNote) && (
                    <div className="tariff-card-popup__price-row">
                        {price && (
                            <div className="tariff-card-popup__price text-xl">
                                <Typografed>{price}</Typografed>
                            </div>
                        )}
                        {priceNote && (
                            <p className="tariff-card-popup__price-note text-xxs">
                                <Typografed>{priceNote}</Typografed>
                            </p>
                        )}
                    </div>
                )}
                {(hasButton || hasAllOptions) && (
                    <div className="tariff-card-popup__actions">
                        {hasButton && (
                            <Link
                                href={button!.href!}
                                target={button!.isExternal ? '_blank' : undefined}
                                rel={button!.isExternal ? 'noreferrer nofollow' : undefined}
                                className="tariff-card-popup__btn text-xs"
                            >
                                <Typografed>{button!.text!}</Typografed>
                            </Link>
                        )}
                        {hasAllOptions && (
                            <button
                                type="button"
                                className="tariff-card-popup__options link link--underlined text-xs"
                                onClick={onAllOptionsClick}
                            >
                                <Typografed>{allOptionsLabel!}</Typografed>
                            </button>
                        )}
                    </div>
                )}
            </div>
        </li>
    );
}

export default TariffCard;
